const style = (theme): any => ({
    dialogContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        alignItems: 'center',
        marginBottom: theme.spacing(1),
        '& > div': {
            flex: `1!important`,
        },
    },
    infoBox: {
        marginTop: theme.spacing(2),
        padding: `${theme.spacing(2.5)}px ${theme.spacing(2)}px`,
        background: '#DAE2FB',
        borderRadius: 4,
        display: 'flex',
        gap: 12,
    },
    dialog: {
        '& .MuiDialog-paperWidthSm': {
            maxWidth: '75%',
        },
    },
});
export default style;
